import React from 'react';
import styles from './Layout.module.scss';

interface LayoutProps {
    title: string;
    icon?: string;
    bgColor1: string;
    bgColor2: string;
    bgColor3: string;
    bgColor4: string;
    bgColor5: string;
    children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ title, icon, bgColor1, bgColor2, bgColor3, bgColor4, bgColor5, children }) => (
    <div className={styles.layout}>
        <header className={styles.header + ' header-layout'}>
            <div className={styles.text}>
                {icon && (
                    <img
                        src={icon}
                        alt=""
                    />
                )}
                <h1>{title}</h1>
            </div>
            <div
                className={styles.bg1}
                style={{ background: bgColor1 }}></div>
            <div
                className={styles.bg2}
                style={{ background: bgColor2 }}></div>
            <div
                className={styles.bg3}
                style={{ background: bgColor3 }}></div>
            <div
                className={styles.bg4}
                style={{ background: bgColor4 }}></div>
            <div
                className={styles.bg5}
                style={{ background: bgColor5 }}></div>
        </header>
        <main className={styles.content}>{children}</main>
    </div>
);
